import { CustomerFeature } from '../../api/models/Shared.types';
import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';
import { Backend } from '../../api/Backend';

export class UserUtil {
  static hasCustomerFeature(backend: Backend, feature: string) {
    return backend.sessionInfo?.customer.features?.includes(feature);
  }

  static rentingAllowed(backend: Backend) {
    if (this.hasCustomerFeature(backend, CustomerFeature.NO_RENT)) return false;
    return backend.globalSettings.boolValue(GlobalSettingsKeys.enablePurchases);
  }
}
